import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateDocument(nodeFields, accept) {
    const { idField, richAssetField } = nodeFields;
    if (!richAssetField || !ast.isRichAssetDocument(richAssetField?.content))
        return;
    if (ast.isStringField(richAssetField.content.value)) {
        // Add a deprecation warning
        accept('warning', `String content for document is being deprecated. Please use the new JSON format.`, {
            node: richAssetField,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.nodeNumber,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
        const urlsValue = richAssetField.content.value.value.toLowerCase();
        validateUrls(urlsValue, richAssetField.content, nodeFields, accept);
    }
    else if (ast.isDocumentJson(richAssetField.content.value)) {
        const documentJson = richAssetField.content.value;
        // Check for duplicate and required properties
        checkForDuplicateAndRequiredProperties({
            node: documentJson,
            allProperties: documentJson.properties,
            requiredProperties: [ast.TypeStaticProperty, ast.UrlsProperty],
            parentNode: nodeFields.refNode,
            accept,
        });
        const urlsProperty = documentJson.properties.find((prop) => {
            return ast.isUrlsProperty(prop);
        });
        if (!urlsProperty)
            return;
        const urlsValue = urlsProperty.urls.value.toLowerCase();
        validateUrls(urlsValue, documentJson, nodeFields, accept);
    }
}
function validateUrls(urlsValue, astNode, nodeFields, accept) {
    const { idField } = nodeFields;
    const urls = urlsValue?.split(',');
    // We should have two comma separated urls in this single property. One
    // for ios and one for android. Separate them out and validate them individually.
    if (urls.length !== 2) {
        accept('error', `Value should have two distinct comma separated URLs, one for ios and other for android.`, {
            node: astNode,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.nodeNumber,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
    }
    else {
        urls.forEach((url) => {
            if (url &&
                (url.trim().startsWith('https://') === false ||
                    url.trim().endsWith('.pdf') === false)) {
                accept('error', `URL should point to a valid PDF file hosted at a secure (https) location.`, {
                    node: astNode,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: nodeFields.nodeNumber,
                        propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                    },
                });
            }
        });
    }
}
//# sourceMappingURL=document.js.map